import { NavLink, useLocation } from "react-router-dom";
import { Home, BookOpen, Sparkles, LayoutGrid, LogIn, BookMarked, Hammer, Landmark } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

// Routes where we suppress the tab bar (full-bleed / public flows).
const HIDDEN_PATHS = [/^\/login/, /^\/signup/, /^\/share\//];
const HIDDEN_ADMIN = /^\/admin/;

function tabClass({ isActive }) {
  return `flex flex-col items-center justify-center gap-1 flex-1 py-2 text-[10px] font-medium uppercase tracking-[0.12em] transition-colors ${
    isActive ? "text-rp-accent" : "text-rp-textFaint hover:text-rp-text active:text-rp-text"
  }`;
}

export default function MobileTabBar() {
  const location = useLocation();
  const { user } = useAuth();

  if (HIDDEN_PATHS.some((re) => re.test(location.pathname))) return null;
  if (HIDDEN_ADMIN.test(location.pathname)) return null;

  return (
    <nav
      className="md:hidden fixed bottom-0 inset-x-0 z-50 rp-glass border-t border-rp-border"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      data-testid="mobile-tabbar"
      aria-label="Primary"
    >
      <div className="flex items-stretch">
        <NavLink to="/" end className={tabClass} data-testid="tab-home">
          {({ isActive }) => (
            <>
              <Home className={`h-5 w-5 ${isActive ? "scale-110 transition-transform" : ""}`} />
              <span>Home</span>
            </>
          )}
        </NavLink>
        <NavLink to="/library" className={tabClass} data-testid="tab-library">
          {({ isActive }) => (
            <>
              <BookOpen className={`h-5 w-5 ${isActive ? "scale-110 transition-transform" : ""}`} />
              <span>Library</span>
            </>
          )}
        </NavLink>
        <NavLink to="/glossary" className={tabClass} data-testid="tab-glossary">
          {({ isActive }) => (
            <>
              <BookMarked className={`h-5 w-5 ${isActive ? "scale-110 transition-transform" : ""}`} />
              <span>Glossary</span>
            </>
          )}
        </NavLink>
        <NavLink to="/india" className={tabClass} data-testid="tab-india">
          {({ isActive }) => (
            <>
              <Landmark className={`h-5 w-5 ${isActive ? "scale-110 transition-transform" : ""}`} />
              <span>India</span>
            </>
          )}
        </NavLink>
        <NavLink to="/tools" className={tabClass} data-testid="tab-tools">
          {({ isActive }) => (
            <>
              <Hammer className={`h-5 w-5 ${isActive ? "scale-110 transition-transform" : ""}`} />
              <span>Tools</span>
            </>
          )}
        </NavLink>

        {/* center FAB-style Finder */}
        <NavLink
          to="/finder"
          className="relative flex flex-col items-center justify-center flex-1 -mt-5"
          data-testid="tab-finder"
        >
          {({ isActive }) => (
            <>
              <span
                className={`grid h-12 w-12 place-items-center rounded-full shadow-[0_8px_24px_rgba(79,124,255,0.45)] transition-transform ${
                  isActive ? "bg-rp-accentHover scale-105" : "bg-rp-accent"
                }`}
              >
                <Sparkles className="h-5 w-5 text-white" />
              </span>
              <span className="mt-1 text-[10px] font-medium uppercase tracking-[0.12em] text-rp-text">
                Finder
              </span>
            </>
          )}
        </NavLink>

        {user ? (
          <NavLink to="/dashboard" className={tabClass} data-testid="tab-dashboard">
            {({ isActive }) => (
              <>
                <LayoutGrid className={`h-5 w-5 ${isActive ? "scale-110 transition-transform" : ""}`} />
                <span>Saved</span>
              </>
            )}
          </NavLink>
        ) : (
          <NavLink to="/login" className={tabClass} data-testid="tab-login">
            {({ isActive }) => (
              <>
                <LogIn className={`h-5 w-5 ${isActive ? "scale-110 transition-transform" : ""}`} />
                <span>Log in</span>
              </>
            )}
          </NavLink>
        )}
      </div>
    </nav>
  );
}
